import { Component, ViewChild } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AddressComponent } from "./address/address.component";
import { ProfileDetailsComponent } from "./profile-details/profile-details.component";
import { AddressDetailsAttributes, BaseAddress, UserDetailsAttributes, UserDetailStatus } from "@models/user.model";
import { UserService } from "../services/user/user.service";
import { SnackBarConfig } from "../constants/snackbar.constants";
import { RouteTrackingService } from "../services/route-tracking/route-tracking.service";

@Component({
    selector: "app-user-details",
    templateUrl: "./user-details.component.html",
    styleUrls: ["./user-details.component.scss"],
    standalone: false,
})
export class UserDetailsComponent {
    @ViewChild(ProfileDetailsComponent) profileDetailRef: ProfileDetailsComponent | undefined;
    @ViewChild(AddressComponent) addressDetailRef: AddressComponent | undefined;

    public location!: AddressDetailsAttributes;
    public profile!: UserDetailsAttributes;
    public address!: BaseAddress;

    constructor(
        private userService: UserService,
        private snackBar: MatSnackBar,
        private router: Router,
        private routerService: RouteTrackingService,
    ) {}

    public submitForm(): void {
        this.userService
            .addUserDetails({
                userDetails: this.profile,
                addressDetails: this.address,
            })
            .subscribe((response) => {
                if (response) {
                    this.openSnackBar(UserDetailStatus.Add, SnackBarConfig.Actions.CLOSE);
                    const navigatePreviousUrl = this.routerService.getPreviousUrl(); // To navigate the previous route
                    this.router.navigate([navigatePreviousUrl]);
                }
            });
    }

    private openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, { duration: SnackBarConfig.Duration.MEDIUM });
    }

    public receiveLocationData(location: AddressDetailsAttributes): void {
        this.location = location;
    }

    public receiveProfileData(profile: UserDetailsAttributes): void {
        this.profile = profile;
    }

    public receiveAddressData(address: BaseAddress): void {
        this.address = address;
    }

    public isFormDataValid(): boolean {
        return !!(this.profileDetailRef?.profileForm.valid && this.addressDetailRef?.addressForm.valid);
    }
}
